import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" data-testid="protected-loading">
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-mono">Loading</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/admin" replace />;
  }
  return children;
}
